// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__X7Hwx","hero-section":"style_hero-section__NrNw5"};